import { Form, type FormItemProps } from 'antd';
import Text from 'antd/lib/typography/Text';

import type { Ii18nLabel } from '@/types/common';

import { getFormItemLabel } from './utils';

interface LabeledSpanProps extends FormItemProps, Ii18nLabel {
  children: any;
  value: string;
}

export function LabeledSpan({ name, label, i18nLabel, rules, value, style }: LabeledSpanProps) {
  const fieldLabel = getFormItemLabel(i18nLabel, label);

  return (
    <Form.Item style={style} name={name} label={fieldLabel} rules={rules}>
      <Text type="secondary">{value}</Text>
    </Form.Item>
  );
}
